import { render, staticRenderFns } from "./ckeditorInput.vue?vue&type=template&id=0a9b227d&scoped=true"
import script from "./ckeditorInput.vue?vue&type=script&lang=js"
export * from "./ckeditorInput.vue?vue&type=script&lang=js"
import style0 from "./ckeditorInput.vue?vue&type=style&index=0&id=0a9b227d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b227d",
  null
  
)

export default component.exports